'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SpotMarker = require('./SpotMarker');

var _SpotMarker2 = _interopRequireDefault(_SpotMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SpotMarker2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SpotMarker/index.js
// module id = 654
// module chunks = 11